import {getElement} from "./helpers.js";
import {modalEvents} from "./modalFunctions.js";

export default function cart() {
    if (!getElement("#cart")) return;
//Todo click add to cart & change counter from js with oho

    const cart = getElement("#cart");
    getElement('#cart-trigger').addEventListener('click', () => {
        modalEvents(getElement('.cart'))
    });
    const shippingCalc = cart.querySelector('[data-shipping-calc]');
    if (!shippingCalc) return;
    shippingCalc.addEventListener('click', () => {
        shippingCalc.parentNode.classList.add('none');
        shippingCalc.parentNode.nextElementSibling.classList.add('active');
    });
    const minus = cart.querySelector('.minus');
    cart.querySelectorAll('.cart__item').forEach(cartItem => {
        cartItem.querySelector('.cart__counter').querySelectorAll('button').forEach(item => {
            const counter = cart.querySelector('.cart__counter').querySelector('.result');
            if (+counter.value == 1) minus.parentElement.classList.add('disabled');
            item.addEventListener('click', () => {
                let result = +counter.value;
                if (item.firstElementChild.classList.contains('plus')) {
                    result = result + 1;
                    counter.value = result;
                    if (minus.parentElement.classList.contains('disabled')) minus.parentElement.classList.remove('disabled');
                } else {
                    if (result == 1) return;
                    result = result - 1;
                    counter.value = result;
                    if (result == 1) item.classList.add('disabled');
                }
            })
        })
    })
}
